// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.insert-link-dialog-content {
  margin-top: 3px;
}
.insert-link-dialog-content .content-select-item-container .mat-mdc-form-field {
  display: block;
  margin-top: 5px;
}
.insert-link-dialog-content .content-select-item-container .extended-search-button {
  width: 100%;
}
.insert-link-dialog-content .content-input-container .mat-mdc-form-field {
  width: 100%;
  margin-top: 5px;
}
.insert-link-dialog-content .content-link-text-input-container.margin-top {
  margin-top: 30px;
}
.insert-link-dialog-content .content-link-text-input-container .mat-mdc-form-field {
  width: 100%;
}
.insert-link-dialog-content .fi-phone-number-contact {
  width: 100%;
  padding-top: 10px;
}
.insert-link-dialog-content .fi-phone-number-contact .fi-countries-select .mat-mdc-form-field {
  width: 100px;
}
.insert-link-dialog-content .fi-phone-number-contact .phone-number-input.mat-mdc-form-field {
  width: 300px;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-text-editor/fi-text-editor-insert-link/text-editor-insert-link-dialog.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ;AACQ;EACI,cAAA;EACA,eAAA;AACZ;AAEQ;EACI,WAAA;AAAZ;AAKQ;EACI,WAAA;EACA,eAAA;AAHZ;AAQQ;EACI,gBAAA;AANZ;AASQ;EACI,WAAA;AAPZ;AAUI;EACI,WAAA;EACA,iBAAA;AARR;AASQ;EACI,YAAA;AAPZ;AASQ;EACI,YAAA;AAPZ","sourcesContent":[".insert-link-dialog-content {\r\n    margin-top: 3px;\r\n    .content-select-item-container {\r\n        .mat-mdc-form-field {\r\n            display: block;\r\n            margin-top: 5px;\r\n        }\r\n\r\n        .extended-search-button {\r\n            width: 100%;\r\n        }\r\n    }\r\n\r\n    .content-input-container {\r\n        .mat-mdc-form-field {\r\n            width: 100%;\r\n            margin-top: 5px;\r\n        }\r\n    }\r\n\r\n    .content-link-text-input-container {\r\n        &.margin-top {\r\n            margin-top: 30px;\r\n        }\r\n\r\n        .mat-mdc-form-field {\r\n            width: 100%;\r\n        }\r\n    }\r\n    .fi-phone-number-contact {\r\n        width: 100%;\r\n        padding-top: 10px;\r\n        .fi-countries-select .mat-mdc-form-field {\r\n            width: 100px;\r\n        }\r\n        .phone-number-input.mat-mdc-form-field {\r\n            width: 300px;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
